import React from "react"
import logo from "../../public/assets/images/ontario_logo.svg"
import UserComponent from "../security/UserComponent";

interface Props {
  callback,
  userLoadedCallBack,
}

export class HeaderComponent extends React.Component<Props> {
 
  constructor(props: Props) {
    super(props);

  }

  header = (
    <div key={'headerkey'}>
      <header className="ontario-header" style={{ height: '90px' }} >
        <div className="ontario-row">
          <div className="ontario-header__logo-container ontario-columns">
            <a href="http://www.ontario.ca">
              <img id="asap-logo" src={logo} alt="Government of Ontario" />
            </a>
          </div>
          <div className="ontario-header__logo-container ontario-columns" style={{ padding: '0', height: 'auto' }}>
            {/* <span id="headerTitle">
              {titleString}
            </span> */}
          </div>
        </div>
      </header>
      <header className='ontario-header mainStreetRow' style={{ height: '64px', background: '#0369AC' }}>
        <div className="ontario-row">
          <div className="ontario-header__logo-container" style={{ padding: '0', height: 'auto', marginRight: 'auto' }}>
            <span id="headerTitle">
              <a href="#" onClick={this.props.callback}> 
              <strong className="ontario-application-subheader__heading" style={{color:'white'}}>Form Builder</strong>
              </a>
            </span>
          </div>
          <div className="ontario-header__nav-right-container ontario-columns ontario-small-10">
           {/* <a id="language-link"> */}
              <p className='ontario-application-subheader__heading'>
                <a className="not-clickable"><UserComponent callback={()=>this.props.userLoadedCallBack()} /></a>
              </p>
            {/* </a> */}
          </div>
        </div>
      </header>
    </div>
  );

  render() {
    return (
      this.header
    )
  }
}
